/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";
import { db } from "~/db/db";
import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";

const useFunilObraProduto = ({ funilObraGrupoProduto, formikRef, name = "funilObraProdutoId" }) => {
  const funilObraProdutoSelect = useSelect("produto");
  const [fila, setFila] = useState(null);
  const [funilObraProduto, setFunilObraProduto] = useState(0);
  const [funilObraProdutoObjeto, setFunilObraProdutoObjeto] = useState({});

  const [funilObraProdutos, setFunilObraProdutos] = useState([]);

  useEffect(() => {
    const fetchFunilObraProdutos = async () => {
      const result = [];
      let query = db.funilObraProdutos;

      if (funilObraGrupoProduto > 0) {
        query = query.where("funilObraGrupoProdutoId").equals(funilObraGrupoProduto);
      }

      await query.each((item) => result.push(item));
      setFunilObraProdutos(result);
    };

    fetchFunilObraProdutos();
  }, [funilObraGrupoProduto]);

  const optionFunilObraProdutos = useMemo(
    () => prepareForOptions(funilObraProdutos, "nome", "id"),
    [funilObraProdutos]
  );

  function onChangeFunilObraProduto(e) {
    funilObraProdutoSelect.upDateValue(e.value);
    funilObraProdutoSelect.upDateDefaultValue(e || "");
    if (formikRef?.current) {
      formikRef.current.setFieldValue(name, e.value);
      setTimeout(() => formikRef.current.setFieldTouched(name, true));
    }
    setFunilObraProduto(e.value);
  }

  function SetSelectFunilObraProduto(id) {
    if (funilObraProdutos?.length) {
      const funilObraProduto = funilObraProdutos.find((o) => o.id === id);
      if (funilObraProduto) {
        onChangeFunilObraProduto({
          value: funilObraProduto.id,
          label: funilObraProduto.nome,
        });
      }

      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila && funilObraProdutos?.length > 0) {
      SetSelectFunilObraProduto(fila);
    }

    if (funilObraProdutos?.length > 0) {
      setFunilObraProdutoObjeto(getColumnIntoKey({ data: funilObraProdutos, prefix: "id-" }));
    }
  }, [fila, funilObraProdutos]);

  function CleanForFilter(option) {
    onChangeFunilObraProduto(option);
  }

  return {
    funilObraProdutos,
    optionFunilObraProdutos,
    funilObraProdutoObjeto,
    onChangeFunilObraProduto,
    SetSelectFunilObraProduto,
    funilObraProduto,
    funilObraProdutoSelect,
    setFunilObraProduto,
    CleanForFilter,
  };
};

export default useFunilObraProduto;
